module.exports = __webpack_public_path__ + "static/media/betting-and-gaming-ux.0cb67fc2.png";